/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function () {
    'use strict';
    var ns = 'http://www.w3.org/2000/svg';

    function isEn() { return /^en(?:-|$)/i.test(document.documentElement.lang || ''); }
    function el(tag, attrs, text) {
        var node = document.createElementNS(ns, tag);
        Object.keys(attrs || {}).forEach(function (key) { node.setAttribute(key, String(attrs[key])); });
        if (text != null) node.textContent = text;
        return node;
    }
    function fmt(value) {
        return Number(value).toLocaleString(isEn() ? 'en' : 'pl-PL', {maximumFractionDigits: 1});
    }
    function labelLines(label) {
        var text=String(label), parts=text.split(/\s+\+\s+/);
        return parts.length===2 ? [parts[0], '+ '+parts[1]] : [text];
    }

    /* ---------- tooltip: jeden na wykres, zdarzenia delegowane na kontener ---------- */
    function state(root) { return root._porownanie || (root._porownanie = {pinned: null, bar: null}); }
    function ensureTooltip(root) {
        var tip = root.querySelector('[data-porownanie-tooltip]');
        if (!tip) {
            tip = document.createElement('div');
            tip.setAttribute('data-porownanie-tooltip', '');
            tip.setAttribute('role', 'status');
            tip.setAttribute('aria-live', 'polite');
            tip.hidden = true;
        }

        return tip;
    }
    function line(tip, text, strong) {
        var node = document.createElement(strong ? 'strong' : 'div');

        node.textContent = text;
        tip.appendChild(node);
    }
    function fill(tip, bar) {
        var en = isEn(), expected = bar.getAttribute('data-expected');
        tip.replaceChildren();
        line(tip, bar.getAttribute('data-porownanie-bar') || '', true);
        line(tip, (jst("pages_wykres_porownanie_js.b18480d11ac8")) + fmt(bar.getAttribute('data-observed') || 0));
        if (expected !== null && expected !== '') line(tip, (jst("pages_wykres_porownanie_js.c251421da938")) + fmt(expected));
        line(tip, 'N = ' + fmt(bar.getAttribute('data-sample-size') || 0));
    }
    // Wspolrzedne liczone w viewporcie i ograniczone do niego, potem przeliczone na kontener.
    function place(root, tip, bar) {
        var b = bar.getBoundingClientRect(), r = root.getBoundingClientRect(), vw = document.documentElement.clientWidth;
        var w = tip.offsetWidth, h = tip.offsetHeight;
        var x = Math.min(Math.max(8, b.left + b.width / 2 - w / 2), Math.max(8, vw - w - 8));
        var y = b.top - h - 8;
        if (y < 8) y = b.bottom + 8;
        tip.style.left = (x - r.left) + 'px';
        tip.style.top = (y - r.top) + 'px';
    }
    function show(root, bar) {
        var tip = ensureTooltip(root);
        if (!tip.parentNode) root.appendChild(tip);
        fill(tip, bar);
        tip.hidden = false;
        state(root).bar = bar;
        place(root, tip, bar);
    }
    function hide(root) {
        var tip = root.querySelector('[data-porownanie-tooltip]');
        if (tip) tip.hidden = true;
        state(root).bar = null;
    }
    function unpin(root) { state(root).pinned = null; hide(root); }
    function reposition(root) {
        var s = state(root), tip = root.querySelector('[data-porownanie-tooltip]');
        if (s.bar && tip && !tip.hidden && root.contains(s.bar)) place(root, tip, s.bar);
    }
    function barOf(target) { return target && target.closest ? target.closest('[data-porownanie-bar]') : null; }
    function bindTooltip(root) {
        if (root.dataset.porownanieTooltip) return;
        root.dataset.porownanieTooltip = '1';
        root.classList.add('wykres-pozycja');
        root.addEventListener('pointerover', function (e) {
            var bar = barOf(e.target);
            if (bar && !state(root).pinned) show(root, bar);
        });
        root.addEventListener('pointerout', function (e) {
            var bar = barOf(e.target);
            if (!bar || state(root).pinned || bar.contains(e.relatedTarget)) return;
            hide(root);
        });
        root.addEventListener('focusin', function (e) {
            var bar = barOf(e.target);
            if (bar && !state(root).pinned) show(root, bar);
        });
        root.addEventListener('focusout', function (e) {
            if (barOf(e.target) && !state(root).pinned) hide(root);
        });
        root.addEventListener('click', function (e) {
            var bar = barOf(e.target), s = state(root);
            if (!bar) return;
            if (s.pinned === bar) { unpin(root); return; }
            s.pinned = bar;
            show(root, bar);
        });
        // scroll nie bąbelkuje, ale capture na kontenerze łapie przewijanie .tabela-scroll
        root.addEventListener('scroll', function () { reposition(root); }, true);
    }
    function roots() { return Array.from(document.querySelectorAll('[data-porownanie-wykres]')); }
    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        roots().forEach(function (root) { if (state(root).pinned || state(root).bar) unpin(root); });
    });
    document.addEventListener('pointerdown', function (e) {
        roots().forEach(function (root) { if (state(root).pinned && !root.contains(e.target)) unpin(root); });
    });
    window.addEventListener('resize', function () { roots().forEach(reposition); });

    /* ---------- render ---------- */
    function render(target, rows, options) {
        var root = typeof target === 'string' ? document.querySelector(target) : target;
        if (!root) return;
        options = options || {};
        bindTooltip(root);
        var tip = ensureTooltip(root);
        tip.hidden = true;
        state(root).pinned = null; state(root).bar = null;
        var title = root.querySelector('h3'), heading = title ? title.cloneNode(true) : null;
        root.replaceChildren();
        if (heading) root.appendChild(heading);
        rows = (rows || []).filter(function (row) { return row && row.label != null && Number.isFinite(Number(row.observed)); });
        var max = rows.reduce(function (m, row) { return Math.max(m, Number(row.observed) || 0, row.expected == null ? 0 : Number(row.expected) || 0); }, 0);
        var en=isEn();
        if (!rows.length || max <= 0) {
            var empty = document.createElement('p'); empty.className = 'tekst-maly';
            empty.textContent = jst("pages_wykres_porownanie_js.2aede451cb8d");
            root.appendChild(empty); root.appendChild(tip); return;
        }
        var defaultTitle=jst("pages_wykres_porownanie_js.98ab1816ae00"), n=options.n||0;
        var multiline=rows.some(function(row){return labelLines(row.label).length>1;});
        var left=42, top=12, field=150, bottom=162, step=multiline?124:76 /* 76 px: patrz komentarz w analizy/_wykres-porownanie.html.twig; obie liczby musza byc takie same */, width=Math.max(360,left+rows.length*step+12), svgHeight=multiline?212:194, points=[];
        var wrap=document.createElement('div'); wrap.className='tabela-scroll'; wrap.tabIndex=0; wrap.setAttribute('role','region'); wrap.setAttribute('aria-label',options.title||defaultTitle);
        var svg=el('svg',{'data-porownanie-svg':'',role:'img','aria-label':options.description||options.title||defaultTitle,viewBox:'0 0 '+width+' '+svgHeight,preserveAspectRatio:jst("ui.7a58849d2b4ff57f")});
        svg.classList.add('wykres-porownanie', 'gra-tekst--' + (options.code || 'lotto'));
        svg.style.width = width + 'px';
        svg.style.minWidth = width + 'px';
        svg.appendChild(el('desc',{},options.description||options.title||''));
        svg.appendChild(el('line',{x1:left,y1:top,x2:left,y2:bottom,stroke:'currentColor',opacity:'.35'}));
        svg.appendChild(el('line',{x1:left,y1:bottom,x2:width-6,y2:bottom,stroke:'currentColor',opacity:'.35'}));
        svg.appendChild(el('text',{x:left-6,y:top+8,'text-anchor':'end','font-size':10,fill:'currentColor'},fmt(max)));
        svg.appendChild(el('text',{x:left-6,y:bottom,'text-anchor':'end','font-size':10,fill:'currentColor'},'0'));
        rows.forEach(function(row,index){
            var cx=left+index*step+step/2, observed=Number(row.observed)||0, expected=row.expected==null?null:Number(row.expected), height=observed*field/max;
            var hasExpected=Number.isFinite(expected);
            var label=String(row.label), aria=label+': '+fmt(observed)+(hasExpected?(jst("pages_wykres_porownanie_js.3ebb765ad2bf"))+fmt(expected):'')+'; N='+n;
            var group=el('g',{'data-porownanie-bar':label,'data-observed':observed,'data-expected':hasExpected?expected:'','data-sample-size':n,tabindex:0,'aria-label':aria});
            group.appendChild(el('title',{},aria));
            group.appendChild(el('rect',{x:cx-13,y:bottom-height,width:26,height:height,rx:2,fill:'currentColor',opacity:'.82'})); svg.appendChild(group);
            var labelNode=el('text',{'data-porownanie-label':'',x:cx,y:bottom+15,'text-anchor':'middle','font-size':10,fill:'currentColor'});
            labelLines(label).forEach(function(line,lineIndex){labelNode.appendChild(el('tspan',{x:cx,y:bottom+15+lineIndex*14},line));});
            svg.appendChild(labelNode);
            if(hasExpected) points.push(cx.toFixed(1)+','+(bottom-expected*field/max).toFixed(1));
        });
        if(points.length>=2) svg.appendChild(el('polyline',{'data-porownanie-model':'',points:points.join(' '),fill:'none',stroke:'#F97316','stroke-width':2,'stroke-dasharray':'6 4','stroke-linejoin':'round'}));
        wrap.appendChild(svg); root.appendChild(wrap);
        var legend=document.createElement('p'); legend.className='tekst-maly';
        legend.textContent=points.length>=2
            ?(jst("pages_wykres_porownanie_js.5d90755004eb"))
            :(jst("pages_wykres_porownanie_js.6fd835d9c25d"));
        root.appendChild(legend);
        root.appendChild(tip);
    }
    function number(text) {
        var clean=String(text||'').replace(/\u00a0/g,' ').replace(/%/g,'').replace(/\s+/g,'').replace(',','.').replace(/[^0-9+\-.]/g,'');
        if(!clean || clean==='—' || clean==='-') return null;
        var value=Number(clean); return Number.isFinite(value)?value:null;
    }
    function bind(root) {
        bindTooltip(root);
        var table=document.querySelector(root.dataset.source||'');
        if(!table) return;
        function update(){
            var li=Number(root.dataset.labelCol||0), oi=Number(root.dataset.observedCol||1), rawExpected=root.dataset.expectedCol;
            var ei=rawExpected===''?null:Number(rawExpected), nEl=root.dataset.nSelector?document.querySelector(root.dataset.nSelector):null, n=number(nEl&&nEl.textContent)||0;
            var rows=Array.from(table.querySelectorAll('tbody tr')).map(function(tr){
                var cells=tr.children;if(!cells.length||!cells[li]||!cells[oi])return null;
                var observed=number(cells[oi].textContent), expected=ei==null||!cells[ei]?null:number(cells[ei].textContent);
                if(expected!=null&&root.dataset.expectedMode==='percent')expected=n*expected/100;
                return {label:cells[li].textContent.trim(),observed:observed,expected:expected};
            }).filter(Boolean);
            var heading=root.querySelector('h3');
            render(root,rows,{title:heading?heading.textContent.trim():(isEn()?jst("ui.3e5b90ae053ff3e7"):jst("ui.8c392169bd1b12b0")),description:root.dataset.description||'',code:root.dataset.code||'lotto',n:n});
        }
        update();
        var body=table.querySelector('tbody'); if(body)new MutationObserver(update).observe(body,{childList:true,subtree:true,characterData:true});
    }
    window.PEWNIAKI_WYKRES_POROWNANIE = {render:render,bind:bind};
    document.querySelectorAll('[data-porownanie-auto]').forEach(bind);
})();
